<template>
	<v-snackbar :color="color" v-model="snackbar" right top
		>{{ message }}
	</v-snackbar>
</template>

<script>
import { EventBus } from '../../../event_bus';
export default {
	name: 'ErrorMessage',
	data() {
		return {
			snackbar: false,
			message: null,
			is_error: false
		}
	},
	created() {
		EventBus.$on('showErrorMessage', ({ message, is_error }) => {
			this.message = message;
			this.is_error = is_error;
			this.snackbar = true;
		});
	},
	computed: {
		color: function () {
			if (this.is_error) return 'red';
			else return 'green';
		}
	}
}
</script>

<style scoped></style>
